import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { SAML } from '../SAML';
import { SBE_SAML } from '../SBE_SAML'; 
import { checkNoChangesView } from '@angular/core/src/view/view';

@Injectable({
  providedIn: 'root'
})
export class GlobalsService {
  public static partner: string = '';
  public static activePartner: string = '';
  public static language: string = '';
  public static saml = {} as SAML;
  public static sbe_saml = {} as SBE_SAML;
  public static redirectURL: string = '';
  public static SBE_ApplicationID: string = '';
  public static SBE_ConsumerReferenceID: string = '';
  public static SBE_Region: string = '';
  public static SBE_Platform: string = '';
  public static SBE_RecentPayment: boolean = false;
  public static SBE_LastPaymentDate: string = '';
  public static SBE_LastPaymentAmount: string = '';
  public static SBE_LastProposedCoverageEffectDate: string = '';
  private SBE_RecentPayment_Subj: BehaviorSubject<boolean>;
  private SBE_InvalidData_Subj: BehaviorSubject<boolean>;
  public static businessName: string = '';
  public static pcpIndicator: boolean = false;
  public static pcpURL: string = '';

  public static lookupPartnerPhoneNum(partner: string) {
    if (partner == 'AHNJ') {
      if (this.SBE_Platform == 'SBE') {
        return '1 - 800 - 313 - 9168';
      } else if(location.href.includes("w3ll")) {
        return '888-968-7241'; 
      }

      return '1 - 888 - 879 - 5331';
    } else if (partner == 'IBC') {
      if (this.SBE_Platform == 'SBE') {
        return '1 - 844 - 438 - 4291';
      } else if(location.href.includes("w3ll")) {
        return '1-800-275-2583'; 
      }
      return '1 - 888 - 475 - 6206';
    } else if (partner == 'HHP') {
        if(GlobalsService.activePartner == 'WNY') {
            return '1 - 844 - 639 - 2441'
        } else if(GlobalsService.activePartner == 'NENY') {
            return '1 - 844 - 639 - 2440'
        } else {
            return '833 - 231 - 8961';
        }
    } else if (partner == 'WY') {
      return '800 - 442 - 2376';
    } else if (partner == 'ND') {
      return '844 - 363 - 8457';
    }
  }

  public static setSAML(Language : string, ApplicationID : string, ConsumerReferenceID : string, MarketIndicator : string, SalesChannel : string, ProposedCoverageEffectiveDate : string, AssignedQHPIdentifier : string,
    FirstName : string, MiddleName : string, LastName : string, SuffixName : string, StreetName1 : string, StreetName2 : string, State : string, CityName : string, ZipCode : string, ContactEmailAddress : string,
    AdditionalInformation : string, ProductLineName : string, productLineCode : string, PlanID : string, AgentID : string, Segment : string, UserType : string, TenantID : string, PlanName : string,
    SuppressCreditCard : string, PremiumAmountTotal : string, PaymentAmount : string, AuthToken : string, ReturnURL : string, PaymentTransactionID : string, UniqueBinderCode : string) {
      //console.log('this.saml', this.saml);
    this.saml.AgentID = AgentID;
    this.saml.ApplicationID = ApplicationID;
    this.saml.AssignedQHPIdentifier = AssignedQHPIdentifier;
    this.saml.AuthToken = AuthToken;
    this.saml.CityName = CityName;
    this.saml.ConsumerReferenceID = ConsumerReferenceID;
    this.saml.ContactEmailAddress = ContactEmailAddress;
    this.saml.FirstName = FirstName;
    this.saml.Language = Language;
    this.language = this.saml.Language;
    this.saml.LastName = LastName;
    this.saml.MarketIndicator = MarketIndicator;
    this.saml.MiddleName = MiddleName;
    this.saml.ConsumerReferenceID = ConsumerReferenceID;
    this.saml.PaymentTransactionID = PaymentTransactionID;
    this.saml.PlanID = PlanID;
    this.saml.PlanName = PlanName;
    this.saml.PremiumAmountTotal = PremiumAmountTotal;
    this.saml.productLineCode = productLineCode;
    this.saml.ProductLineName = ProductLineName;
    this.saml.ProposedCoverageEffectiveDate = ProposedCoverageEffectiveDate;
    this.saml.ReturnURL = ReturnURL;
    this.saml.SalesChannel = SalesChannel;
    this.saml.Segment = Segment;
    this.saml.State = State;
    this.saml.StreetName1 = StreetName1;
    this.saml.StreetName2 = StreetName2;
    this.saml.SuffixName = SuffixName;
    this.saml.SuppressCreditCard = SuppressCreditCard;
    this.saml.TenantID = TenantID;
    this.saml.PaymentAmount = PaymentAmount;
    this.saml.UniqueBinderCode = UniqueBinderCode;
    this.saml.UserType = UserType;
    this.saml.ZipCode = ZipCode;
}

public static setSAML_SBE(StreetName2 : string, AssignedQHPIdentifier : string, StreetName1 : string,
  PartnerAssignedConsumerID : string, FirstName : string, MiddleName : string, PaymentTransactionID : string,
  ContactEmailAddress : string, AdditionalInformation : string, APTCAmount : string, TotalAmountOwned : string,
  ZipCode : string, State : string, ProposedCoverageEffectiveDate : string, Language : string,
  PremiumAmountTotal : string, CityName : string, MarketIndicator : string, SubscriberIdentifier : string,
  LastName : string, Region : string, Platform : string, UniqueBinderCode : string, UserType : string, AgentID : string,
  SuffixName?: string, ProductLineName?: string, PlanName?: string, AdditionalProperties?: string, TINIdentification?: string,
   Dob?: string, Issuer?: string, ApplicationID?: string) {
    //console.log('this.saml', this.saml);

    this.sbe_saml.StreetName2 = StreetName2;
    this.sbe_saml.AssignedQHPIdentifier = AssignedQHPIdentifier;
    this.sbe_saml.StreetName1 = StreetName1;
    this.sbe_saml.PartnerAssignedConsumerID = PartnerAssignedConsumerID;
    this.sbe_saml.FirstName = FirstName;
    this.sbe_saml.MiddleName = MiddleName;
    //this.sbe_saml.PaymentTransactionID = PaymentTransactionID;
    this.sbe_saml.ConsumerReferenceID = PaymentTransactionID;
    this.sbe_saml.ContactEmailAddress = ContactEmailAddress;
    this.sbe_saml.AdditionalInformation = AdditionalInformation;
    this.sbe_saml.APTCAmount = APTCAmount;
    this.sbe_saml.TotalAmountOwed = TotalAmountOwned;
    this.sbe_saml.ZipCode = ZipCode;
    this.sbe_saml.State = State;
    this.sbe_saml.ProposedCoverageEffectiveDate = ProposedCoverageEffectiveDate;
    this.sbe_saml.Language = Language;
    this.language = this.sbe_saml.Language;
    this.sbe_saml.PremiumAmountTotal = PremiumAmountTotal;
    this.sbe_saml.CityName = CityName;
    this.sbe_saml.MarketIndicator = MarketIndicator;
    this.sbe_saml.SubscriberIdentifier = SubscriberIdentifier;
    this.sbe_saml.LastName = LastName;
    this.sbe_saml.Region = Region;
    this.sbe_saml.Platform = Platform;
    this.sbe_saml.UniqueBinderCode = UniqueBinderCode; 
    this.sbe_saml.UserType = UserType; 
    this.sbe_saml.AgentID = AgentID;
    this.sbe_saml.SuffixName = SuffixName;
    this.sbe_saml.ProductLineName = ProductLineName;
    this.sbe_saml.PlanName= PlanName;
    this.sbe_saml.AdditionalProperties = AdditionalProperties;
    this.sbe_saml.TINIdentification = TINIdentification;
    this.sbe_saml.Dob = Dob;
    this.sbe_saml.Issuer = Issuer;
    this.sbe_saml.ApplicationID = ApplicationID;
    this.sbe_saml.PaymentTransactionID = PaymentTransactionID;

}



constructor() { 
  this.SBE_RecentPayment_Subj = new BehaviorSubject<boolean>(false); 
  this.SBE_InvalidData_Subj = new BehaviorSubject<boolean>(false);
}

setValue(newValue): void {
  this.SBE_RecentPayment_Subj.next(newValue);
}

setValueInvalidData(newValue): void {
  this.SBE_InvalidData_Subj.next(newValue);
}

getValue(): Observable<boolean> {
  return this.SBE_RecentPayment_Subj.asObservable();
}

getValueInvalidData(): Observable<boolean> {
  return this.SBE_InvalidData_Subj.asObservable();
}

}
